// extracted by mini-css-extract-plugin
export default {"emojiContainer":"styles_emojiContainer__2uQNU"};